import './StickyPageHeader.less';

import React, { ReactNode, useEffect, useState } from 'react';

interface StickyPageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  isAdmin?: boolean;
  actions?: ReactNode;
}

const StickyPageHeader: React.FC<StickyPageHeaderProps> = ({
  actions,
  isAdmin = false,
  subtitle,
  title,
}) => {
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const stored = localStorage.getItem('menuCollapsed');
    return stored && JSON.parse(stored) ? 65 : 250;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem('menuCollapsed');
      setSidebarWidth(stored && JSON.parse(stored) ? 65 : 250);
    };
    window.addEventListener('menuCollapsedChange', handleStorageChange);

    return () => {
      window.removeEventListener('menuCollapsedChange', handleStorageChange);
    };
  }, []);

  return (
    <>
      <div className="sticky-page-header" style={{ left: sidebarWidth }}>
        <div className="sticky-page-header__content">
          <div className="sticky-page-header__left">
            <h1 className="sticky-page-header__title">{title}</h1>
            {(subtitle || isAdmin) && (
              <div>
                {isAdmin ? (
                  <span className="sticky-page-header__admin-badge">Admin</span>
                ) : (
                  <span className="sticky-page-header__carrier-name">
                    {subtitle}
                  </span>
                )}
              </div>
            )}
          </div>
          {actions && (
            <div className="sticky-page-header__actions">{actions}</div>
          )}
        </div>
      </div>
      <div className="sticky-page-header__spacer" />
    </>
  );
};

export default StickyPageHeader;
